<template lang="html">
    <!-- result info
    ================================================== -->
    <div class="row content-result-info">
        <div class="col-full">
            <p class="lead">
                We have found <strong>{{ total }}</strong> results
                <span v-if="query">
                    for <strong>{{ query }}</strong>
                </span>
                <span v-if="styles.length || subjects.length|| types.length|| locations.length">
                    within 
                    <span v-if="styles.length" v-for="item in styles">
                        <strong>{{ item }}</strong>,
                    </span>
                    <span v-if="subjects.length" v-for="item in subjects">
                        <strong>{{ item }}</strong>,
                    </span>
                    <span v-if="types.length" v-for="item in types">
                        <strong>{{ item }}</strong>,
                    </span>
                    <span v-if="locations.length" v-for="item in locations">
                        <strong>{{ item }}</strong>,
                    </span>
                </span>
            </p>
        </div>
    </div>
</template>

<script>
// Components for showing information about search results and search filters

import _ from 'lodash';

export default {
  props: {
    'total': Number,
    'query': String,
    'styles': Array,
    'subjects': Array,
    'types': Array,
    'locations': Array,
  }
};
</script>
